export default "__VITE_ASSET__acd15532__"